import React from "react";
import SocialLinks from "./SocialLinks";

export default function Footer() {
  return (
    <footer className="border-t border-gray-800 mt-16">
      <div className="container mx-auto px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-6">
        <p className="gray-font text-sm text-center sm:text-left">
          © {new Date().getFullYear()} Andy Fransisko. All rights reserved.
        </p>
        <SocialLinks />
        <a
          href="#top"
          className="gray-font text-sm hover:text-white transition-colors"
        >
          <i className="fa fa-arrow-up mr-2 text-teal-500" aria-hidden="true"></i>
          Back to top
        </a>
      </div>
    </footer>
  );
}
